<template>
  <div class="app-home px-2"> 

    <!-- Old Header  -->
    <!-- <div class="row py-4 mb-3">
        <div class="col text-center">
            <h2 class="mb-0 mt-3 mb-4">Fantastic and Unique CSS Gradients</h2>
            <div class="grad-bar mb-4"></div>
            <div class="">Explore <strong>{{totalCollections}}</strong> collections and over <strong>{{totalGradients}}</strong> unique CSS gradients</div>
        </div>
    </div> -->

    <div class="jumbotron bg-white mb-0">
      <h2 class="display-4 mb-3">Gradient Magic</h2>
      <div class="grad-bar mb-4"></div>
      <p class="lead">A Free Gallery of Fantastic and Unique CSS Gradients</p>
    </div>

    <div class="text-left">
      <h4 class="mt-1 mb-2">
        <strong>Popular</strong> Collections
      </h4>
      <collection-list collectionType="POPULAR"  :max="6" />

      <h4 class="mt-3 mb-2"><strong>More</strong> Collections</h4>
      <collection-list collectionType="RANDOM" :max="6" />
    </div>

    <router-link class="btn btn-outline-dark my-4 px-5" to="/browse">
        See All Collections
    </router-link>

  </div>
</template>

<script>
// @ is an alias to /src
import CollectionList from '@/components/CollectionList.vue';
import collections from '@/util/collections.js'
import gradients from '@/util/gradients.js'

const SLIDESHOW_INTERVAL = 10000;

export default {
  name: 'home',
  components: {
    CollectionList
  },
  data(){
    return {
      activeFilter: "CREATED"
    }
  },
  methods: {
  },
  computed: {
    totalCollections(){
      return collections.length;
    },
    totalGradients(){
      return gradients.length;
    }
  },
}
</script>

<style lang="scss">
.app-home {
  .grad-bar {
    height: 4px;
    margin: 0 auto;
    width: 12rem;
    background: linear-gradient(90deg, #f47178 0%, #f47178 14.3%, #f4da71 14.3%, #f4da71 28.6%, #9df471 28.6%, #9df471 42.9%, #71f4b5 42.9%, #71f4b5 57.2%, #71c2f4 57.2%, #71c2f4 71.5%, #9071f4 71.5%, #9071f4 85.8%, #f471e7 85.8%, #f471e7 100.1%);
  }

  // .mt-45 {
  //   margin-top: 2rem !important;
  // }
  // .px-6 {
  //   padding-left: 5rem!important;
  //   padding-right: 5rem!important
  // }

  // @keyframes animateJumbotron {
  //   0% {
  //     // Cool Grid
  //     background-image: repeating-linear-gradient(135deg, rgba(0,0,0,0.03) 0px, rgba(0,0,0,0.03) 1px,transparent 1px, transparent 31px,rgba(0,0,0,0.03) 31px, rgba(0,0,0,0.03) 32px,transparent 32px, transparent 92px),repeating-linear-gradient(45deg, rgba(0,0,0,0.03) 0px, rgba(0,0,0,0.03) 1px,transparent 1px, transparent 31px,rgba(0,0,0,0.03) 31px, rgba(0,0,0,0.03) 32px,transparent 32px, transparent 92px),repeating-linear-gradient(90deg, rgba(0,0,0,0.03) 0px, rgba(0,0,0,0.03) 1px,transparent 1px, transparent 31px,rgba(0,0,0,0.03) 31px, rgba(0,0,0,0.03) 32px,transparent 32px, transparent 92px),linear-gradient(90deg, hsl(344,0%,100%),hsl(344,0%,100%));
  //   }
  
  //   33% {
  //     // Radial
  //     background-image: radial-gradient(circle at 13% 47%, rgba(140, 140, 140,0.03) 0%, rgba(140, 140, 140,0.03) 25%,transparent 25%, transparent 100%),radial-gradient(circle at 28% 63%, rgba(143, 143, 143,0.03) 0%, rgba(143, 143, 143,0.03) 16%,transparent 16%, transparent 100%),radial-gradient(circle at 81% 56%, rgba(65, 65, 65,0.03) 0%, rgba(65, 65, 65,0.03) 12%,transparent 12%, transparent 100%),radial-gradient(circle at 26% 48%, rgba(60, 60, 60,0.03) 0%, rgba(60, 60, 60,0.03) 6%,transparent 6%, transparent 100%),radial-gradient(circle at 97% 17%, rgba(150, 150, 150,0.03) 0%, rgba(150, 150, 150,0.03) 56%,transparent 56%, transparent 100%),radial-gradient(circle at 50% 100%, rgba(25, 25, 25,0.03) 0%, rgba(25, 25, 25,0.03) 36%,transparent 36%, transparent 100%),radial-gradient(circle at 55% 52%, rgba(69, 69, 69,0.03) 0%, rgba(69, 69, 69,0.03) 6%,transparent 6%, transparent 100%),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255));
  //   }


  //   66% {
  //     // Linear
  //     background-image: linear-gradient(135deg, transparent 0%, transparent 6%,rgba(71, 71, 71,0.04) 6%, rgba(71, 71, 71,0.04) 22%,transparent 22%, transparent 100%),linear-gradient(45deg, transparent 0%, transparent 20%,rgba(71, 71, 71,0.04) 20%, rgba(71, 71, 71,0.04) 47%,transparent 47%, transparent 100%),linear-gradient(135deg, transparent 0%, transparent 24%,rgba(71, 71, 71,0.04) 24%, rgba(71, 71, 71,0.04) 62%,transparent 62%, transparent 100%),linear-gradient(45deg, transparent 0%, transparent 73%,rgba(71, 71, 71,0.04) 73%, rgba(71, 71, 71,0.04) 75%,transparent 75%, transparent 100%),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255));
  //   }

  //   100% {
  //     // Cool Radial
  //     background-image: radial-gradient(circle at 7% 98%, rgba(151, 151, 151,0.03) 0%, rgba(151, 151, 151,0.03) 81%,transparent 81%, transparent 100%),radial-gradient(circle at 89% 30%, rgba(178, 178, 178,0.03) 0%, rgba(178, 178, 178,0.03) 13%,transparent 13%, transparent 100%),radial-gradient(circle at 9% 13%, rgba(105, 105, 105,0.03) 0%, rgba(105, 105, 105,0.03) 19%,transparent 19%, transparent 100%),radial-gradient(circle at 16% 13%, rgba(11, 11, 11,0.03) 0%, rgba(11, 11, 11,0.03) 5%,transparent 5%, transparent 100%),radial-gradient(circle at 25% 93%, rgba(113, 113, 113,0.03) 0%, rgba(113, 113, 113,0.03) 18%,transparent 18%, transparent 100%),linear-gradient(90deg, rgb(255,255,255) 0%, rgb(255,255,255) 50%,rgb(255,255,255) 50%, rgb(255,255,255) 100%);
  //   }
  // }

  // .bg-promo {    
  //   // Cool Grids
  //   // background-image: repeating-linear-gradient(135deg, rgba(0,0,0,0.03) 0px, rgba(0,0,0,0.03) 1px,transparent 1px, transparent 31px,rgba(0,0,0,0.03) 31px, rgba(0,0,0,0.03) 32px,transparent 32px, transparent 92px),repeating-linear-gradient(45deg, rgba(0,0,0,0.03) 0px, rgba(0,0,0,0.03) 1px,transparent 1px, transparent 31px,rgba(0,0,0,0.03) 31px, rgba(0,0,0,0.03) 32px,transparent 32px, transparent 92px),repeating-linear-gradient(90deg, rgba(0,0,0,0.03) 0px, rgba(0,0,0,0.03) 1px,transparent 1px, transparent 31px,rgba(0,0,0,0.03) 31px, rgba(0,0,0,0.03) 32px,transparent 32px, transparent 92px),linear-gradient(90deg, hsl(344,0%,100%),hsl(344,0%,100%));
    
  //   // Radial
  //   // background-image: radial-gradient(circle at 13% 47%, rgba(140, 140, 140,0.03) 0%, rgba(140, 140, 140,0.03) 25%,transparent 25%, transparent 100%),radial-gradient(circle at 28% 63%, rgba(143, 143, 143,0.03) 0%, rgba(143, 143, 143,0.03) 16%,transparent 16%, transparent 100%),radial-gradient(circle at 81% 56%, rgba(65, 65, 65,0.03) 0%, rgba(65, 65, 65,0.03) 12%,transparent 12%, transparent 100%),radial-gradient(circle at 26% 48%, rgba(60, 60, 60,0.03) 0%, rgba(60, 60, 60,0.03) 6%,transparent 6%, transparent 100%),radial-gradient(circle at 97% 17%, rgba(150, 150, 150,0.03) 0%, rgba(150, 150, 150,0.03) 56%,transparent 56%, transparent 100%),radial-gradient(circle at 50% 100%, rgba(25, 25, 25,0.03) 0%, rgba(25, 25, 25,0.03) 36%,transparent 36%, transparent 100%),radial-gradient(circle at 55% 52%, rgba(69, 69, 69,0.03) 0%, rgba(69, 69, 69,0.03) 6%,transparent 6%, transparent 100%),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255));

  //   // Linear    
  //   // background-image: linear-gradient(135deg, transparent 0%, transparent 6%,rgba(71, 71, 71,0.04) 6%, rgba(71, 71, 71,0.04) 22%,transparent 22%, transparent 100%),linear-gradient(45deg, transparent 0%, transparent 20%,rgba(71, 71, 71,0.04) 20%, rgba(71, 71, 71,0.04) 47%,transparent 47%, transparent 100%),linear-gradient(135deg, transparent 0%, transparent 24%,rgba(71, 71, 71,0.04) 24%, rgba(71, 71, 71,0.04) 62%,transparent 62%, transparent 100%),linear-gradient(45deg, transparent 0%, transparent 73%,rgba(71, 71, 71,0.04) 73%, rgba(71, 71, 71,0.04) 75%,transparent 75%, transparent 100%),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255));

  //   // Cool Dots
  //   background-image: repeating-radial-gradient(circle at center center, transparent 0px, transparent 13px,rgba(0,0,0,0.03) 13px, rgba(0,0,0,0.03) 24px,transparent 24px, transparent 62px,rgba(0,0,0,0.03) 62px, rgba(0,0,0,0.03) 96px),repeating-radial-gradient(circle at center center, rgb(255,255,255) 0px, rgb(255,255,255) 14px,rgb(255,255,255) 14px, rgb(255,255,255) 18px,rgb(255,255,255) 18px, rgb(255,255,255) 28px,rgb(255,255,255) 28px, rgb(255,255,255) 32px); background-size: 21px 21px;

  //   // Cool overlapping circles
  //   // background-image: radial-gradient(circle at 78% 68%, rgba(202, 202, 202,0.03) 0%, rgba(202, 202, 202,0.03) 3%,transparent 3%, transparent 100%),radial-gradient(circle at 19% 32%, rgba(134, 134, 134,0.03) 0%, rgba(134, 134, 134,0.03) 5%,transparent 5%, transparent 100%),radial-gradient(circle at 91% 31%, rgba(47, 47, 47,0.03) 0%, rgba(47, 47, 47,0.03) 26%,transparent 26%, transparent 100%),radial-gradient(circle at 8% 65%, rgba(6, 6, 6,0.03) 0%, rgba(6, 6, 6,0.03) 8%,transparent 8%, transparent 100%),radial-gradient(circle at 81% 75%, rgba(168, 168, 168,0.03) 0%, rgba(168, 168, 168,0.03) 10%,transparent 10%, transparent 100%),linear-gradient(90deg, rgb(255,255,255) 0%, rgb(255,255,255) 50%,rgb(255,255,255) 50%, rgb(255,255,255) 100%);
  //   // background-image: radial-gradient(circle at 7% 98%, rgba(151, 151, 151,0.03) 0%, rgba(151, 151, 151,0.03) 81%,transparent 81%, transparent 100%),radial-gradient(circle at 89% 30%, rgba(178, 178, 178,0.03) 0%, rgba(178, 178, 178,0.03) 13%,transparent 13%, transparent 100%),radial-gradient(circle at 9% 13%, rgba(105, 105, 105,0.03) 0%, rgba(105, 105, 105,0.03) 19%,transparent 19%, transparent 100%),radial-gradient(circle at 16% 13%, rgba(11, 11, 11,0.03) 0%, rgba(11, 11, 11,0.03) 5%,transparent 5%, transparent 100%),radial-gradient(circle at 25% 93%, rgba(113, 113, 113,0.03) 0%, rgba(113, 113, 113,0.03) 18%,transparent 18%, transparent 100%),linear-gradient(90deg, rgb(255,255,255) 0%, rgb(255,255,255) 50%,rgb(255,255,255) 50%, rgb(255,255,255) 100%);
  //   // background-color: white;
    
  //   // Best Rainbow
  //   // background-image: linear-gradient(45deg, hsl(160,83%,71%),hsl(211.429,83%,71%),hsl(262.857,83%,71%),hsl(314.286,83%,71%),hsl(5.714,83%,71%),hsl(57.143,83%,71%),hsl(108.571,83%,71%)),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255))

  //   // animation: animateJumbotron 20s infinite;
  // }

  // Underline effect
  // h2 {
  //   span {
  //     background-size: 100% 5%;
  //     background-repeat: repeat-x;
  //     background-position: left 0% bottom 10%;
  //     background-image: linear-gradient(90deg, #f47178 0%, #f47178 14.3%, #f4da71 14.3%, #f4da71 28.6%, #9df471 28.6%, #9df471 42.9%, #71f4b5 42.9%, #71f4b5 57.2%, #71c2f4 57.2%, #71c2f4 71.5%, #9071f4 71.5%, #9071f4 85.8%, #f471e7 85.8%, #f471e7 100.1%);
  //   }
  // }

//   .promo-box {
//     width: 100%;
//     a {
//       text-decoration: underline;
//     }

//     // Home rainbow (smooth)
//     background: linear-gradient(90deg, #f47178, #f4da71, #9df471, #71f4b5, #71c2f4, #9071f4, #f471e7);
//  }

}
</style>
